import { render, staticRenderFns } from "./liveDetails.vue?vue&type=template&id=2e7c4198&scoped=true&"
import script from "./liveDetails.vue?vue&type=script&lang=js&"
export * from "./liveDetails.vue?vue&type=script&lang=js&"
import style0 from "./liveDetails.vue?vue&type=style&index=0&id=2e7c4198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c4198",
  null
  
)

export default component.exports